import React from 'react';
import { Helmet } from 'react-helmet';

const SEO = ({}) => (
    <Helmet title = {'RKS Radgoszcz'}
            htmlAttributes={{ lang: 'en' }}
    />
);

export default SEO;
